import { Route, Routes as DomRoutes } from 'react-router-dom';

import MarkdownContent from '@/components/Ui/MarkdownContent';
import ConfirmDialog from '@/dialogs/ConfirmDialog';

export interface DialogRouteState {
    dialogAction: string;
    message?: string | null;
    params?: Record<string, unknown>;
    [key: string]: unknown;
}

interface DialogRoutesProps {
    state: DialogRouteState;
}

export default function DialogRoutes({ state }: DialogRoutesProps) {
    const { dialogAction: action, message = null } = state;
    const [
        module,
        method,
    ] = action.split('.');

    if (module === 'generic') {
        if (method === 'confirm') {
            return (
                <DomRoutes>
                    <Route element={ <ConfirmDialog>
                        <MarkdownContent className='prose' content={ message ?? 'Please confirm that you want to proceed.' } />
                    </ConfirmDialog> } path='*' />
                </DomRoutes>
            );
        }
    }

    return null;
}
